import React from 'react';
import type { Vehicle } from '@hero/schema';
import { getObjectId } from '@hero/schema';
import { useTranslation } from 'react-i18next';
import { useMyOrdersListApi } from '@hero/api-hooks';
import { SharedList } from '../../../app/List/List';
import { OrderCard } from '../../Order/Card/OrderCard';

export interface VehicleOrdersTabProps {
  vehicle: Vehicle;
}

export function VehicleOrdersTab({ vehicle }: VehicleOrdersTabProps) {
  const { t } = useTranslation(['m-vehicle']);

  // Carrier-side view of orders this vehicle is on, scoped by tenant
  // visibility via `getMyOrders`. The `as_carrier` lens narrows to
  // orders where the viewing org is the seller — the drawer is only
  // meaningful when the viewing org owns this vehicle. `vehicleId` is
  // already part of `myOrdersAPISchema` (inherited from
  // `ordersQueryAPISchema`), so no schema work is needed here.
  const ordersQuery = useMyOrdersListApi({
    vehicleId: getObjectId(vehicle._id),
    lens: 'as_carrier',
  });

  return (
    <div className="flex flex-col gap-3 p-5">
      <SharedList
        query={ordersQuery}
        emptyMessage={t('drawer.no_orders')}
        className="gap-3"
        renderItem={order => <OrderCard order={order} displayForUser="carrier" />}
      />
    </div>
  );
}
